/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";

export const JsonFieldViewer = (props) => {
        const { Value } = props;
        return Value != null ? <span className="pndlm-line-break">{JSON.stringify(Value, undefined, 2)}</span> : "";
}
